import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Check, Languages, LogOut, User } from 'lucide-react';
import {
  Avatar,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@elbklar/ui';
import { useAuth } from '@/features/auth/AuthContext';
import { kontoUrl } from '@/lib/konto';
import { SearchBar } from './SearchBar';

const SPRACHEN = [
  { code: 'de', name: 'Deutsch' },
  { code: 'en', name: 'English' },
];

/**
 * Suche und Benutzermenü — rechts in jedem Seitenkopf, nur am Rechner. Am
 * Handy stehen Profil und Abmelden in „Mehr“ der Tab-Leiste (CRMLayout), die
 * Suche oben in „Kunden“. Benachrichtigungen sitzen im Sidebar-Fuß.
 */
export function GlobalActions() {
  return (
    <div className="flex items-center gap-2 max-md:hidden">
      <SearchBar />
      <Benutzermenue />
    </div>
  );
}

function Benutzermenue() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { i18n } = useTranslation();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Benutzermenü"
          className="inline-flex cursor-pointer items-center rounded-full transition-opacity hover:opacity-88"
        >
          <Avatar name={user?.name || 'Benutzer'} src={user?.avatar_url || undefined} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64">
        <div className="flex items-center gap-3 px-2 py-2">
          <Avatar name={user?.name || 'Benutzer'} src={user?.avatar_url || undefined} size="lg" />
          <div className="min-w-0 flex-1">
            <p className="truncate t-body-strong">{user?.name}</p>
            <p className="truncate t-small text-muted-foreground">{user?.email}</p>
          </div>
        </div>
        <DropdownMenuSeparator />
        {/* Profil fuehrt nach konto.elbklar.com: es haengt am User, nicht an
            dieser App. Benachrichtigungen und ihre Einstellungen stehen im
            Panel aus dem Sidebar-Fuss. */}
        <DropdownMenuItem icon={User} onSelect={() => (window.location.href = kontoUrl('/profil'))}>
          Profil
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuLabel>
          <span className="inline-flex items-center gap-1.5">
            <Languages size={14} strokeWidth={1.75} aria-hidden />
            Sprache
          </span>
        </DropdownMenuLabel>
        {SPRACHEN.map((s) => (
          <DropdownMenuItem key={s.code} onSelect={() => i18n.changeLanguage(s.code)}>
            <span className="flex items-center justify-between">
              {s.name}
              {i18n.language === s.code && <Check size={16} strokeWidth={1.75} className="text-highlight" aria-hidden />}
            </span>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem icon={LogOut} onSelect={handleLogout}>
          Abmelden
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
